<template>
	<div class="fullPage"    >
		<!-- Header -->
		<v-layout class="pa-5 guideHeader" >			
			<v-layout  justify-end align-center>  
				<v-flex>
					<v-btn class="mr-2" icon @click="setMenuOpen(true)"><v-icon>menu</v-icon></v-btn>         
				</v-flex>
	            <v-flex shrink>
	            </v-flex>
	            <v-flex class="topTitlePhone" style="">
	            	<v-layout row>
	            	<img src="https://interactivefloorplans.arizona.edu/static/img/ua_block_rgb_3.3c82a4c.3c82a4c.png" class="phoneBlocka mr-5">
	                <div class="display-1">Room Finder Developer Guide</div>
	            	</v-layout>
	            </v-flex>
	            <v-flex style="" class="text-xs-right">
	         	</v-flex>
        	</v-layout>
        </v-layout>

        <!-- Lower Area -->	
        <v-container class="lowerPortion" >
          

		<v-layout fill-height >
			<v-flex xs5 class="contentArea" >
				<div class="body-1 scrollContent" style="height:100%;">
					<v-card class="pa-5 mb-5" color="white" >
						<v-card-title>Room Finder</v-card-title>
						<v-card-text class="px-4">
							Room Finder is an embeddable application to show a highlighted room or building on a map.<br>
							Click on the links below to see how the embedded map changes with different URL inputs.
						</v-card-text>
					</v-card>

					<v-card class="pa-5 mb-5" color="white" >
						<v-card-title class="mb-5">Developer Usage</v-card-title>
						<v-card-text class="px-4">
							Using <i>Highlight As A Service</i> (HAAS) developers can highlight rooms using an embeded map by simply changing the src attribute.<br><br>

							&lt;embed id="embed-roomfinder" :src="<b>targetURL</b>" style="width:700px; height: 700px;"&gt;

						</v-card-text>
					</v-card>
					<v-card class="pa-4 mb-5" color="white" >
						<v-card-title class="mb-5">API</v-card-title>
						
						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Simple Highlight
							</div>
							<div class="caption mb-3">
								Format: highlight/buildingNumber/RoomNumber
							</div>
							<span @click="changeTarget('highlight/21/0109')" 
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/highlight/21/0109</span><br>
							<span @click="changeTarget('highlight/241')" 
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/highlight/241</span>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Coloring Room Groups
							</div>
							<div class="caption mb-3">
								<span>Format: ?highlightRoomsV2=&lt;color&gt;&lt;roomKeys&gt;~&lt;color&gt;&lt;roomKeys&gt;</span>
							</div>
							<div @click="changeTarget('?highlightRoomsV2=<63,81,181><0300.01-A104,0300.01-A106>~<163,81,81><0300.01-A108,0300.01-A108B,0300.01-A107A,0300.01-A105A,0300.01-A105C,0300.01-A100A,0300.01-A101,0300.01-A100NW>~<63,181,81><0300.01-A109,0300.01-A109A,0300.01-A117,0300.01-A119,300B-B102>')" 
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/?highlightRoomsV2=<br><63,81,181><0300.01-A104,0300.01-A106>~<br><163,81,81><0300.01-A108,0300.01-A108B,0300.01-A107A,0300.01-A105A,0300.01-A105C,0300.01-A100A,0300.01-A101,0300.01-A100NW>~<br><63,181,81><0300.01-A109,0300.01-A109A,0300.01-A117,0300.01-A119,300B-B102></div>
						</v-card-text>

<!-- 						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Coloring Room Groups
							</div>
							<div class="caption mb-3">
								Format: ?highlightRooms=[color][roomKeys]:[color][roomKeys]
							</div>
							<div @click="changeTarget('?highlightRooms=[63,81,181][300A-A104,300A-A106]:[163,81,81][300A-A108,300A-A108B,300A-A107A,300A-A105A,300A-A105C,300A-A100A,300A-A101,300A-A100NW]:[63,181,81][300A-A109,300A-A109A,300A-A117,300A-A119,300B-B102]')" 
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/?highlightRooms=<br>[63,81,181][300A-A104,300A-A106]:<br>[163,81,81][300A-A108,300A-A108B,300A-A107A,300A-A105A,300A-A105C,300A-A100A,300A-A101,300A-A100NW]:<br>[63,181,81][300A-A109,300A-A109A,300A-A117,300A-A119,300B-B102]</div>
						</v-card-text> -->

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Labeling Rooms
							</div>
							<div class="caption mb-3">
								Format: ?labels=[{"bldg":buildingNumber,"rooms":[roomNumberArray],"labels":[labelArray]}]<br>
								Multiple buildings supported in labels array.  Works best for adjacent/overlapping buildings.
							</div>
							<div @click="changeTarget('?labels=' + JSON.stringify(labelsObject))"
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/?labels={{JSON.stringify(labelsObject)}}
							</div>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Hover Labeling by Group
							</div>
							<div class="caption mb-3">
								Format: ?highlightRooms=[group color][group label][roomKeys]&hoverLabelTitle=string | 'none'<br>
								This feature requires use of the hoverLabelTitle parameter
							</div>
							<div @click="changeTarget('?highlightRooms=[63,81,181][Blue][300A-A300,300A-A306]&hoverLabelTitle=Team')" 
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/?highlightRooms=[63,81,181][Blue][300A-A300,300A-A306]&hoverLabelTitle=Team</div>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Hover Labeling by Room
							</div>
							<div class="caption mb-3">
								Format: ?highlightRooms=[group color][values][roomKeys]&hoverLabelTitle=string | 'none'<br>
								[values] corresponds 1:1 with roomKeys<br>
								This feature requires use of the hoverLabelTitle parameter
								
							</div>
							<div @click="changeTarget('?highlightRooms=[63,81,181][11,22][300A-A300,300A-A306]&hoverLabelTitle=Coffee Cups')" 
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/?highlightRooms=[63,81,181][11,22][300A-A300,300A-A306]&hoverLabelTitle=Coffee Cups</div>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Highlighting and Labeling Buildings
							</div>
							<div class="caption mb-3">
								Format: ?buildings=[{bldg,color,label,labelColor,haloSize,haloColor,fontSize}]<br>
								Only bldg property is required<br>
								Color can be [RGB] or [RGBA] (A)lpha sets opacity
							</div>
							<div @click="changeTarget('?buildings=' + JSON.stringify(buildingsSimple))"
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/?buildings={{JSON.stringify(buildingsSimple)}}
							</div>
							<br>
							<div @click="changeTarget('?buildings=' + JSON.stringify(buildingsObject) + '&basemap=enterprise')"
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/?buildings={{JSON.stringify(buildingsObject)}}&basemap=enterprise
							</div>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Floor
							</div>
							<div class="caption mb-3">
								Format: ?floor=floornumber<br>
								This is not needed for room highlighting<br>
							</div>
							<div @click="changeTarget('?floor=2')"
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/?floor=2
							</div>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Elevator
							</div>
							<div class="caption mb-3">
								Format: ?elevator=true | false | dark<br>
								Default is false; dark will invert color of elevator<br>
								Enabled automatically on building highlight<br>
							</div>
							<div @click="changeTarget('?elevator=true')"
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/?elevator=true
							</div>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Lat / Long Point Markers
							</div>
							<div class="caption mb-3">
								Format: ?points=[{latLong,label,markerSize,markerColor,markerOutlineColor,xLabelOffset,yLabelOffset,labelColor,haloSize,haloColor,fontSize}]<br>
								Color can be [RGB] or [RGBA] (A)lpha sets opacity
							</div>
							<div @click="changeTarget('?points=' + JSON.stringify(pointsObject) + '&basemap=enterprise&hideInterior=true')"
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/?points={{JSON.stringify(pointsObject)}}&basemap=enterprise&hideInterior=true
							</div>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Custom Title
							</div>
							<div class="caption mb-3">
								Format: ?title=My Title
							</div>
							<div @click="changeTarget('highlight/21/0109/?title=Silver and Sage Room')" 
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/highlight/21/0109/?title=Silver and Sage Room</div>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Floorplan Line Detail
							</div>
							<div class="caption mb-3">
								Format: ?detail=true
							</div>
							<div @click="changeTarget('highlight/21/0109/?detail=true')" 
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/highlight/21/0109/?detail=true</div>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Set Zoom Level
							</div>
							<div class="caption mb-3">
								Format: ?zoomLevel=level
							</div>
							<div @click="changeTarget('highlight/241/?zoomLevel=17')" 
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/highlight/241/?zoomLevel=17</div>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Top Labels
							</div>
							<div class="caption mb-3">
								Basemap labels can get covered by rooms.  topLabels=true places titles on top.
								<br>Format: ?topLabels=true
							</div>
							<div @click="changeTarget('highlight/21/0109/?topLabels=true')" 
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/highlight/21/0109/?topLabels=true</div>
						</v-card-text>

						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Hide Interior
							</div>
							<div class="caption mb-3">
								Will hide all rooms
								<br>Format: ?hideInterior=true
							</div>
							<div @click="changeTarget('highlight/21/?hideInterior=true')" 
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/highlight/21/?hideInterior=true</div>
						</v-card-text>
						<v-card-text class="px-4">
							<div class="body-1 font-weight-bold">
								Alternate Basemaps
							</div>
							<div class="caption mb-3">
								Use an alternative basemap
								<br>Format: ?basemap=enterprise | public
							</div>
							<div @click="changeTarget('highlight/21/?basemap=enterprise')" 
								class="fakeURL" style="text-decoration: underline;">http://roomfinder.arizona.edu/highlight/21/?basemap=enterprise</div>
						</v-card-text>

					</v-card>
					<v-card class="pa-5 mb-5" color="white" >
						<v-card-title class="mb-5">Combining Functions</v-card-title>
						<v-card-text class="px-4">
							Most of the API features can be used concurrently.  When stringing together paramaters, be aware the first starts with ? and subsequent parameters begin with &<br><br>

							https://roomfinder.arizona.edu/<span style="color: red;"><b>?</b></span>detail=true<span style="color: red;"><b>&</b></span>basemap=public<span style="color: red;"><b>&</b></span>title=Fruits

							<br><br>
							Using a <a href="https://jsonformatter.org/115bf8" target="_blank">JSON Validation tool</a> can be very helpful for complex queries

						</v-card-text>
					</v-card>
				</div>
			</v-flex>
			<v-flex xs7>

				<div class="pa-5 map">
					<div class="mb-2" :key="resetCurrentURL">
						<a :href="currentURL" target="_blank">{{currentURL}}</a>
					</div>					
					<embed id="embed-roomfinder" :src="targetURL" :key="resetEmbed"
					:style="'width:' + mapWidth +'; height:' + mapHeight + ';'" 
					style="border-width: 1px; border-style: solid;">
					<div style="align-text: center;"> 
						<span @click="mapSize('sm')" style="text-decoration: underline; cursor: pointer;">sm </span>
						<span>| </span>
						<span @click="mapSize('med')" style="text-decoration: underline; cursor: pointer;">med</span> 
						<span> | </span>
						<span @click="mapSize('lrg')" style="text-decoration: underline; cursor: pointer;">lrg</span>
					</div>
				</div>
			</v-flex>
		</v-layout>
		</v-container>	

	</div>

</template>

<script>

//import { loadModules } from 'esri-loader'
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {

	data () {
	    return {
	        targetURL: null,
	        resetEmbed: 1,
	        resetCurrentURL: 10000,
	        currentURL: null,
	        mapWidth: '700px',
	        mapHeight: '700px',
	        labelsObject: [{"bldg":"300A","rooms":["A306","A316","A313","A339","A319","A303","A300S"],"labels":["Headquarters", "Chocolate Chip\nCookies","Milk","Snack Station","BBQ Pit","Petting Zoo","Barista"]}],
	        buildingsObject: [{"bldg":"36","color":[255,0,0,0.5],"label":"Red Bldg","labelColor":[0,255,0],"haloSize":10,"haloColor":[0,0,255],"fontSize":36},{"bldg":"21","color":[255,255,0,0.5],"label":"Yellow Bldg","labelColor":[255,255,255],"haloSize":5,"haloColor":[0,255,0]}],
	        buildingsSimple: [{"bldg":"75"},{"bldg":"75A"}],
	        pointsObject: [{"latLong":"-110.9534412, 32.2318614","markerColor":[255,0,0,0.5],"outlineColor":[0,0,255],"label":"Exhibit 1","markerSize":180,"labelColor":[0,255,0],"haloSize":2,"haloColor":[0,0,255],"fontSize":36, "yLabelOffset":-40},{"latLong":"-110.9510, 32.231879","markerColor":[255,255,0,1],"label":"Exhibit 2","labelColor":[0,0,255],"haloSize":1,"haloColor":[255,0,0,0.25]},{"latLong":"-110.9525, 32.231879","label":"Feature 1","xLabelOffset":40},{"latLong":"-110.9530, 32.232100","label":"Feature 2"},{"latLong":"-110.9540263, 32.2320872","label":"Feature3"} ],
	    }
	},

	computed: {
		...mapState({	selectedBuilding: state => state.space.selectedBuilding,
						selectedRoom: state => state.space.selectedRoom,
						mapReady: state => state.ui.mapReady,
						baseURL: state => state.ui.baseURL,	
					}),
	},

	mounted: function() {
		this.targetURL = this.baseURL
		this.resetEmbed = this.resetEmbed + 1 // forceReset by moving 'key'
		setInterval(this.getCurrentURL, 1000);
	},


	methods: {
		...mapMutations(['setMenuOpen' ]),
		...mapActions(['']),

		changeTarget(value) {
			//console.log("ChangeTarget: ", value)
			this.targetURL = this.baseURL + value
			this.resetEmbed = this.resetEmbed + 1 // forceReset by moving 'key'
			this.getCurrentURL()
	    },

	    mapSize(size) {
	    	if (size == "sm") { this.mapWidth = "400px"; this.mapHeight = "400px"; }
	    	if (size == "med") { this.mapWidth = "700px"; this.mapHeight = "700px"; }
	    	if (size == "lrg") { this.mapWidth = "calc(50vw - 50px)"; this.mapHeight = "calc(100vh - 250px)"; }
	    },

	    getCurrentURL () {

			// Selecting the element
    		const element = document.getElementById("embed-roomfinder");

	    	// Get the src attribute value
	    	let link = element && element.getAttribute("src");
	    	this.resetCurrentURL = this.resetCurrentURL + 1
	    	this.currentURL = link
	    },
		
	}
}

</script>



<style>

.fullPage {
	height: 50px;
	background-color: black;
}

.guideHeader {
	position: fixed;
	background-color: rgb(250, 250, 250);
	width: 100%;
	height: 100px;
	box-shadow: 0px 0px 10px -2px #000;
	z-index: 2;
}

.lowerPortion {
	position: relative;
	top: 120px;
	padding-left: 80px;
	overflow-y: auto;
}

.contentArea {
	height: calc(100vh - 170px);	
	
}

.scrollContent {
	padding-right: 30px;
	overflow-y: auto;
}

.fakeURL {
	text-decoration: underline;
	cursor: pointer;
}

.map {
	height:100%; 
	text-align: center; 
}

::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgb(200, 200, 200); 
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, .1); 
} 

::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, .3);  
}

/* Buttons */
::-webkit-scrollbar-button:single-button {
  background-color: rgb(250, 250, 250);
  display: block;
  border-style: solid;
  height: 8px;
  width: 10px;
}

/* Up */
::-webkit-scrollbar-button:single-button:vertical:decrement {
  border-width: 0 5px 5px 5px;
  border-color: transparent transparent #555555 transparent;
}

::-webkit-scrollbar-button:single-button:vertical:decrement:hover {
  border-color: transparent transparent #777777 transparent;
}
/* Down */
::-webkit-scrollbar-button:single-button:vertical:increment {
  border-width: 5px 5px 0 5px;
  border-color: #555555 transparent transparent transparent;
}
</style>
